import { render, staticRenderFns } from "./NewOrganisation.vue?vue&type=template&id=70cd6d6c&scoped=true"
import script from "./NewOrganisation.vue?vue&type=script&lang=js"
export * from "./NewOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd6d6c",
  null
  
)

export default component.exports